// Bridges ui.ts's cast handler to GameScene for a Separate·Mass cast -- the
// first real effect for the Bind/Separate operator pair (every prior room's
// puzzle has only ever used Transfer, Momentum's sub-effect, or Project).
// Deliberately structural, not a quantity transfer, matching how resolve()
// already describes Bind/Separate·Mass: splitting one rock into two smaller
// ones (or, with the Reverse modifier, rejoining two same-tier rocks on
// adjacent tiles back into one) conserves the total mass either way, so
// there's no Energy cost the way Transfer/Momentum/Project all have -- see
// design/12_Mechanics_Mass_Momentum.md.
//
// The event/result shapes themselves moved to rune-lab/src/sim/casts.ts with the
// handler that consumes them (2026-07-30, sim extraction step 4b) and are
// re-exported here unchanged, so every import site still reads them from this
// module.
import { SeparateEffectEvent, SeparateEffectResult, SeparateFailureReason } from '../../rune-lab/src/sim/casts';

export type { SeparateEffectEvent, SeparateEffectResult, SeparateFailureReason };

type Handler = (event: SeparateEffectEvent) => SeparateEffectResult;

let handler: Handler | null = null;

export function onSeparateEffect(fn: Handler): void {
  handler = fn;
}

export function triggerSeparateEffect(event: SeparateEffectEvent): SeparateEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '' };
}
